<template>
  <div @click="handleClick" style="cursor:pointer">
    <el-progress
      :percentage="percent ? percent : 0"
      class="custom-el-progress"
    ></el-progress>
    <div class="progress-p-container">
      <p class="progress-p">
        <template v-if="$t('language.name') == 'En'">
          <countTo
            :startVal="startVal"
            :endVal="endVal"
            :duration="3000"
            :autoplay="true"
          />
          <span class="progress-text">{{ $t("summary.tonext") }}</span>
        </template>
        <template v-else>
          <span class="progress-text">{{ $t("summary.tonext") }}</span>
          <countTo
            :startVal="startVal"
            :endVal="endVal"
            :duration="3000"
            :autoplay="true"
          ></countTo>
          <span class="progress-text">{{ $t("summary.blocks") }}</span>
        </template>
      </p>
      <div class="block-summary-desc">
        <p class="block-summary-desc-text1">
          <span v-if="['zh', 'ja'].includes($i18n.locale)">{{ $t("stake.left") }}</span>
          <span class="block-summary-value">{{ days }}</span>
          {{ $t("stake.days") }}
          <span class="block-summary-value">{{ hours }}</span>
          {{ $t("stake.hours") }}
          <span v-if="['en', 'ko'].includes($i18n.locale)">{{ $t("stake.left") }}</span>
        </p>
        <p class="block-summary-desc-text2">{{ $t("stake.currnetround1") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from "vue-count-to";
export default {
  name: "homeProgress",
  components: { countTo },
  props: {
    blocks: {
      type: Number,
    },
  },
  computed: {
    blockToNext() {
      return this.$store.getters.blockstonext || 0;
    },
    percent() {
      let amount = this.$store.getters.blockstonext.count_to_next_round || 0;
      let total =
        this.$store.getters.blockstonext.max_staking_change_count || 0;
      let per = Math.round((total - amount) / (total / 100));
      return per == 100 ? 99 : per;
    },
  },
  data() {
    return {
      startVal: 0,
      endVal: 0,
      days: 0,
      hours: 0,
      blockAmount: 0,
    };
  },
  watch: {
    blockAmount: function(newValue, oldValue) {
      this.endVal = newValue;
      if (oldValue == 0) {
        this.startVal = newValue;
      } else {
        this.startVal = oldValue;
      }
    },
    blockToNext: function() {
      this.blockAmount = this.blockToNext.count_to_next_round;
      let lastime = this.blockToNext.left_time_to_next_round;
      this.days = Math.floor(lastime / 86400);
      this.hours = Math.floor((lastime - this.days * 86400) / 3600);
      if (this.days < 1 && this.hours < 1) {
        this.hours = 1;
      }
    },
  },
  methods: {
    handleClick() {
      this.$router.push("/stake");
    }
  }
};
</script>
<style lang="scss" scoped>
.progress-p-container {
  @include pc {
    display: flex;
    justify-content: space-between;
    align-content: center;
  }
  @include mobile {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  margin-top: 16px;
  .block-summary-desc {
    @include mobile {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    .block-summary-desc-text1 {
      font-family: "Inter";
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      color: rgba(24, 23, 23, 0.4);
    }
    .block-summary-value {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      color: #181717;
    }
    .block-summary-desc-text2 {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;

      text-align: center;

      color: rgba(24, 23, 23, 0.4);
    }
  }
}
.progress-p {
  text-align: left;
}

.progress-p span {
  font-size: 16px;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 22px;
}
.lang_en .progress-p span {
  font-family: NunitoSans-Bold, "Avenir", Helvetica, Arial, sans-serif;
}
.progress-text {
  color: #808080 !important;
}
</style>
<style>
.custom-el-progress .el-progress-bar__outer {
  height: 8px !important;
}
.custom-el-progress .el-progress-bar__inner {
  height: 8px !important;
  background: linear-gradient(
    107.67deg,
    #78cdeb 0.53%,
    #48a3ff 100%
  ) !important;
}
.el-progress__text {
  display: none;
}
.el-progress-bar {
  margin-right: 0;
  padding-right: 0;
}
</style>